import activityConfig from "emun.activity/activity.config";
import templateUrl from "emun.customer/customer-map.htm";
import mapConfig from "emun.customer/map.config";
import resolve from "ioc/resolve";
import AutoQuery from "servicestack/auto-query/auto-query";
import basicController from "servicestack/basic.controller.properties";
import $appConfig from "servicestack/config";
import ServiceBus from "servicestack/service-bus";

let storeIndex = 0;

export class Store {
  constructor(dto) {
    var store = this;
    Object.assign(store, dto);
    store.storeId = store.id;
    store.salesData = store.salesDetails ? JSON.parse(store.salesDetails) : "";
    (store.id = store.id), //storeIndex++;
      (store.placeId = "");
    store.latitude = dto.latitude || 0.0;
    store.longitude = dto.longitude || 0.0;
    store.target = false;
    store.placeId = "";
    store.animation = "";
    store.matched = false;
    store.vendorMatched = true;
    store.sourceMatched = true;
    store.showcodeMatched = true;
    store.dollarMatched = true;
    store.fillColor = "";
    store.icon =
      "M8.412,24.5C1.317,14.21,0,13.155,0,9.375a9.375,9.375,0,0,1,18.75,0c0,3.78-1.317,4.835-8.412,15.121a1.172,1.172,0,0,1-1.926,0Zm.963-11.215A3.906,3.906,0,1,0,5.469,9.375,3.906,3.906,0,0,0,9.375,13.281Z";
    //		store.icon = dto.markerType == 'Customer' ? 'M8.412,24.5C1.317,14.21,0,13.155,0,9.375a9.375,9.375,0,0,1,18.75,0c0,3.78-1.317,4.835-8.412,15.121a1.172,1.172,0,0,1-1.926,0Zm.963-11.215A3.906,3.906,0,1,0,5.469,9.375,3.906,3.906,0,0,0,9.375,13.281Z' : 'M24-8c0,4.4-3.6,8-8,8h-32c-4.4,0-8-3.6-8-8v-32c0-4.4,3.6-8,8-8h32c4.4,0,8,3.6,8,8v32z';
    store.location =
      (store.address || "") +
      " " +
      (store.city || "") +
      ", " +
      (store.state || "") +
      " " +
      (store.zip || "") +
      " USA";
  }
}

export class CustomerMapController {
  constructor(utils) {
    basicController(this);
    const $ctrl = this;
    $ctrl.$appConfig = $appConfig;
    $ctrl.bus = new ServiceBus();
    $ctrl.utils = utils;
    $ctrl.map = {
      //zoom: 12,
      //center: $ctrl.customer.address + ", " + $ctrl.customer.city + ", " + $ctrl.customer.state + " " + $ctrl.customer.zip + " USA",
      store: null,
    };
    $ctrl.mapConfig = mapConfig;
    $ctrl.activityConfig = activityConfig;
    var timezone = moment.tz.guess();
    var date = moment.tz(timezone);
    $ctrl.startDate = moment(date);
    $ctrl.endDate = moment(date);
    $ctrl.startDateString = $ctrl.startDate.format("MM/DD/YYYY");
    $ctrl.endDateString = $ctrl.endDate.format("MM/DD/YYYY");
    $ctrl.dateRange = "Today";
    $ctrl.vendors = [];
    $ctrl.sources = [];
    $ctrl.categories = [];
    $ctrl.showcodes = [];
    $ctrl.dollars = [];
    $ctrl.dateRanges = [
      {
        id: "Today",
        title: "Today",
      },
      {
        id: "Tomorrow",
        title: "Tomorrow",
      },
      {
        id: "This Week",
        title: "This Week",
      },
      {
        id: "Next Week",
        title: "Next Week",
      },
    ];
    $ctrl.dollarRanges = [
      {
        range: "$0",
        low: -99999999,
        high: 0,
        color: "red",
      },
      {
        range: "$1 - $2499",
        low: 1,
        high: 2499,
        color: "orange",
      },
      {
        range: "$2500 - $4999",
        low: 2500,
        high: 4999,
        color: "yellow",
      },
      {
        range: "$5000 - $7499",
        low: 5000,
        high: 7499,
        color: "blue",
      },
      {
        range: "$7500 - $9999",
        low: 7500,
        high: 9999,
        color: "navy",
      },
      {
        range: "$10000+",
        low: 10000,
        high: 999999999,
        color: "green",
      },
    ];
    if ($ctrl.customerId) {
      setTimeout(function () {
        $ctrl.selectRetailer({ id: $ctrl.customerId });
      }, 2000);
    }
  }
  getFillColor(totalSales) {
    let $ctrl = this;
    var color = "black";
    $ctrl.dollarRanges.forEach(function (range) {
      if (totalSales >= range.low && totalSales <= range.high) {
        color = range.color;
      }
    });
    return color;
  }
  filterIcons() {
    let $ctrl = this;
    $ctrl.query.results.forEach(function (res) {
      res.vendorMatched = true;
      res.categoryMatched = true;
      res.sourceMatched = true;
      res.showcodeMatched = true;
      res.dollarMatched = true;
    });
    $ctrl.query.results.forEach((res) => (res.matched = false));
    if ($ctrl.vendors.length > 0) {
      $ctrl.query.results.forEach((res) => (res.vendorMatched = false));
      $ctrl.vendors.forEach(function (vendor) {
        $ctrl.query.results.forEach(function (res) {
          var obj = res.salesData.filter(function (obj) {
            return obj.VendorName === vendor;
          });
          if (obj.length > 0) {
            res.vendorMatched = true;
          }
        });
      });
    }
    if ($ctrl.categories.length > 0) {
      $ctrl.query.results.forEach((res) => (res.categoryMatched = false));
      $ctrl.categories.forEach(function (category) {
        $ctrl.query.results.forEach(function (res) {
          var obj = res.salesData.filter(function (obj) {
            return obj.Category === category;
          });
          if (obj.length > 0) {
            res.categoryMatched = true;
          }
        });
      });
    }
    if ($ctrl.sources.length > 0) {
      $ctrl.query.results.forEach((res) => (res.sourceMatched = false));
      $ctrl.sources.forEach(function (source) {
        $ctrl.query.results.forEach(function (res) {
          var obj = res.salesData.filter(function (obj) {
            return obj.Source === source;
          });
          if (obj.length > 0) {
            res.sourceMatched = true;
          }
        });
      });
    }
    if ($ctrl.showcodes.length > 0) {
      $ctrl.query.results.forEach((res) => (res.showcodeMatched = false));
      $ctrl.showcodes.forEach(function (showcode) {
        $ctrl.query.results.forEach(function (res) {
          var obj = res.salesData.filter(function (obj) {
            return obj.ShowCode === showcode;
          });
          if (obj.length > 0) {
            res.showcodeMatched = true;
          }
        });
      });
    }
    if ($ctrl.dollars.length > 0) {
      $ctrl.query.results.forEach((res) => (res.dollarMatched = false));
      $ctrl.dollars.forEach(function (dollar) {
        //var range = $ctrl.dollarRanges.filter(s => s.range == dollar);
        $ctrl.query.results.forEach(function (res) {
          if (res.totalSales >= dollar.low && res.totalSales <= dollar.high) {
            res.dollarMatched = true;
          }
        });
      });
    }
    $ctrl.query.results.forEach(function (res) {
      res.fillColor = "gray";
      if (
        res.vendorMatched &&
        res.sourceMatched &&
        res.categoryMatched &&
        res.showcodeMatched &&
        res.dollarMatched
      ) {
        if (res.markerType == "Customer" || res.markerType == "Shipping") {
          res.fillColor = $ctrl.getFillColor(res.totalSales);
        } else if (res.markerType == "Prospect") {
          res.fillColor = "purple";
        }
        //else if (res.markerType == "Shipping") {
        //	res.fillColor = 'black';
        //}
      }
    });
  }
  toggleMapFilters() {
		const slide = document.getElementById("map-filters");
		console.log('john');
		if (slide) {
		  slide.classList.toggle("in");
		}
	}
  toggleVendor(vendorId) {
    let $ctrl = this;
    var idx = $ctrl.vendors.indexOf(vendorId);
    if (idx > -1) {
      $ctrl.vendors.splice(idx, 1);
    } else {
      $ctrl.vendors.push(vendorId);
    }
    $ctrl.filterIcons();
  }
  toggleCategory(categoryId) {
    let $ctrl = this;
    var idx = $ctrl.categories.indexOf(categoryId);
    if (idx > -1) {
      $ctrl.categories.splice(idx, 1);
    } else {
      $ctrl.categories.push(categoryId);
    }
    $ctrl.filterIcons();
  }
  toggleSource(sourceId) {
    let $ctrl = this;
    var idx = $ctrl.sources.indexOf(sourceId);
    if (idx > -1) {
      $ctrl.sources.splice(idx, 1);
    } else {
      $ctrl.sources.push(sourceId);
    }
    $ctrl.filterIcons();
  }
  toggleShowcode(showcode) {
    let $ctrl = this;
    var idx = $ctrl.showcodes.indexOf(showcode);
    if (idx > -1) {
      $ctrl.showcodes.splice(idx, 1);
    } else {
      $ctrl.showcodes.push(showcode);
    }
    $ctrl.filterIcons();
  }
  toggleDollar(dollar) {
    let $ctrl = this;

    var idx = $ctrl.dollars.indexOf(dollar);
    if (idx > -1) {
      $ctrl.dollars.splice(idx, 1);
    } else {
      $ctrl.dollars.push(dollar);
    }
    $ctrl.filterIcons();
  }

  goHome() {
    let $ctrl = this;
    $ctrl.customer = null;
    $ctrl.query.criteria.Id = "";
    $ctrl.getGeoZip();
    //resolve("$http")
    //	.get("https://ipinfo.io/json")
    //	.then(
    //		res => {
    //			if (res && res.data && res.data.postal) {
    //				$ctrl.query.criteria.Zip = res.data.postal;
    //				$ctrl.map.center = res.data.postal + " USA";
    //				$ctrl.query.load(true);
    //			} else {
    //				this.getGeoZip();
    //			}
    //		},
    //		res => this.getGeoZip()
    //	);
  }

  $onInit() {
    let $ctrl = this;

    let options = {
      url: "GetMapMarkers.json",
      scrub(response) {
        response.data.results = _.sortBy(response.data.results, "companyName");
        response.data.results = response.data.results.map((r) => new Store(r));
        $ctrl.bounds = new google.maps.LatLngBounds();
        response.data.results.forEach(function (store, index) {
          if (!store.latitude || !store.longitude) {
            setTimeout(function () {
              $ctrl.geocodeLocation(store);
            }, 200);
          } else {
            var latlng = new google.maps.LatLng(
              store.latitude,
              store.longitude
            );
            $ctrl.bounds.extend(latlng);
            $ctrl.map.instance.fitBounds($ctrl.bounds);
          }
          if (store.markerType === "Activity") {
            store.fillColor = "black";
          } else if (store.markerType === "Prospect") {
            store.fillColor = "purple";
          } else {
            store.fillColor = $ctrl.getFillColor(store.totalSales);
          }
        });
        setTimeout(function () {
          console.debug("BL*** in timeout select store", $ctrl.customerId);
          if ($ctrl.customerId) {
            console.debug("BL*** selecting store", $ctrl.customerId);
            var filteredMarkers = response.data.results.filter(
              (obj) => obj.id === $ctrl.customerId
            );
            console.debug("BL*** filteredMarkers", filteredMarkers);
            if (filteredMarkers.length > 0) {
              $ctrl.selectStore(filteredMarkers[0]);
            }
          }
        }, 2000);
      },
      criteria: {
        Radius: 5,
        includeCustomers: false,
        includeProspects: false,
        includeSalesData: true,
        ExcludeCustomerByAccountType:
          $ctrl.mapConfig.ExcludeCustomerByAccountType,
      },
      autoLoad: false,
      append: false,
    };
    if ($ctrl.customer) {
      options.criteria.Id = $ctrl.customer.id;
      options.criteria.Zip = $ctrl.customer.zip;
      options.autoLoad = true;
      options.criteria.includeCustomers = true;
      options.criteria.markerType = "Customer";
    }

    $ctrl.query = new AutoQuery(options);

    resolve("NgMap")
      .getMap()
      .then(function (map) {
        map.$ctrl = $ctrl;
        $ctrl.map.instance = map;

        $ctrl.placesService = new google.maps.places.PlacesService(map);

        if ($ctrl.customer) {
          $ctrl.lookupPlace($ctrl.customer, false);
        }
        //				$ctrl.getGeoZip();
      });

    $ctrl.goHome();
  }

  findRetailers(val) {
    const $ctrl = this;
    let url = `QueryRetailersSearch.json?Take=5&Status=Active&Search=${val}&OrderBy=CompanyName`; //
    console.log("QueryRetailersSearch.$item", url);
    return $ctrl.bus.send(url).then((res) => res.data.results);
  }

  selectRetailer(val) {
    const $ctrl = this;
    var retailerQuery = new AutoQuery({
      url: "QueryRetailers.json?includeSalesData=1&Id=" + val.id,
      orderBy: "CompanyName",
      autoLoad: true,
      onLoaded: function (args) {
        $ctrl.customer = new Store(args.first);
        $ctrl.customer.fillColor = $ctrl.getFillColor(
          $ctrl.customer.totalSales
        );
        $ctrl.customer.id = $ctrl.customer.storeId;
        $ctrl.$onInit();
      },
    });
  }

  geocodeLocation(store) {
    let $ctrl = this;
    var httpConfig = {
      headers: {
        Pragma: undefined,
        "Cache-Control": undefined,
        "X-Requested-With": undefined,
        "If-Modified-Since": undefined,
      },
    };
    resolve("$http")
      .get(
        "https://maps.googleapis.com/maps/api/geocode/json?address=" +
          store.location.replace("#", "") +
          "&components=postal_code:" +
          store.zip +
          "&key=AIzaSyALMtF7jirmQSaowmNd9PuIVFGCzxnBdYM&callback=googleMapsReady",
        httpConfig
      )
      .then(
        (res) => {
          if (res && res.data.results && res.data.results.length > 0) {
            store.latitude = res.data.results[0].geometry.location.lat;
            store.longitude = res.data.results[0].geometry.location.lng;
            store.placeId = res.data.results[0].place_id;
            var latlng = new google.maps.LatLng(
              store.latitude,
              store.longitude
            );
            $ctrl.bounds.extend(latlng);
            $ctrl.map.instance.fitBounds($ctrl.bounds);
          }
        }
        //				res => this.getGeoZip()
      );
    //$ctrl.lookupPlace(store);
  }

  lookupPlace(store, openMap) {
    let $ctrl = this;
    var placeRequest = {
      query: store.companyName + " " + store.location,
      fields: ["place_id", "opening_hours", "permanently_closed", "geometry"],
    };

    return $ctrl.placesService.findPlaceFromQuery(
      placeRequest,
      function (results, status) {
        if (results) {
          store.placeId = results[0].place_id;
          store.opening_hours = results[0].opening_hours;
          store.permanently_closed = results[0].permanently_closed;
          store.latitude = results[0].geometry.location.lat;
          store.longitude = results[0].geometry.location.lng;
        }
        if (openMap) {
          if (store.placeId) {
            window.open(
              "https://www.google.com/maps/search/?api=1&query=" +
                store.companyName +
                "&query_place_id=" +
                store.placeId
            );
          } else {
            var geoSearchString =
              store.address +
              " " +
              store.city +
              ", " +
              store.state +
              " " +
              store.zip;
            window.open("http://www.google.com/maps/place/" + geoSearchString);
          }
        }
      }
    );
  }

  selectDateRange() {
    const $ctrl = this;
    if ($ctrl.dateRange === "Today") {
      $ctrl.startDate = moment();
      $ctrl.endDate = moment();
    } else if ($ctrl.dateRange === "Tomorrow") {
      $ctrl.startDate = moment().add("days", 1);
      $ctrl.endDate = moment().add("days", 1);
    } else if ($ctrl.dateRange === "Next Week") {
      $ctrl.startDate = moment().startOf("week").add("days", 7);
      $ctrl.endDate = moment().startOf("week").add("days", 14);
    } else if ($ctrl.dateRange == "This Week") {
      $ctrl.startDate = moment().startOf("week");
      $ctrl.endDate = moment().startOf("week").add("days", 7);
    }
    $ctrl.startDateString = $ctrl.startDate.format("MM/DD/YYYY");
    $ctrl.endDateString = $ctrl.endDate.format("MM/DD/YYYY");

    $ctrl.query.load(true);
  }

  toggleCustomers() {
    let $ctrl = this;
    $ctrl.query.criteria.includeCustomers =
      !$ctrl.query.criteria.includeCustomers;
    $ctrl.loadQuery();
  }

  toggleInActiveRecords() {
    let $ctrl = this;
    $ctrl.query.criteria.includeInActiveCustomers =
      !$ctrl.query.criteria.includeInActiveCustomers;
    $ctrl.loadQuery();
  }

  toggleShipLocations() {
    let $ctrl = this;
    $ctrl.query.criteria.includeShipLocations =
      !$ctrl.query.criteria.includeShipLocations;
    $ctrl.loadQuery();
  }

  toggleProspects() {
    let $ctrl = this;
    $ctrl.query.criteria.includeProspects =
      !$ctrl.query.criteria.includeProspects;
    $ctrl.loadQuery();
  }

  downloadData() {
    let $ctrl = this;
    var itemsFormatted = [];

    var headers = {
      CompanyName: "Company Name",
      CustomerId: "Customer ID",
      Address: "Address",
      City: "City",
      State: "State",
      Zip: "Zip",
      TotalSales: "TotalSales",
      LastOrdered: "LastOrdered",
    };

    // format the data
    $ctrl.query.results.forEach((item) => {
      itemsFormatted.push({
        CompanyName: item.companyName.replace(/,/g, "").replace(/,/g, ""), // remove commas to avoid errors,
        SalesRep: item.id.replace(/,/g, "").replace(/,/g, ""),
        Address: item.address.replace(/,/g, ""),
        City: item.city.replace(/,/g, ""),
        State: item.state.replace(/,/g, ""),
        Zip: item.zip.replace(/,/g, ""),
        TotalSales: item.totalSales,
        LastOrdered: moment(item.lastOrderedOn).format("MM/DD/YYYY"),
      });
    });

    var fileTitle = "map-export";
    $ctrl.utils.exportCSVFile(headers, itemsFormatted, fileTitle);
  }

  export() {
    let $ctrl = this;
    var url = $ctrl.$appConfig.resolveServiceUrl(
      "" + $ctrl.query.url.replace(".json", ".csv")
    );
    return (location.href = url);
  }

  loadQuery() {
    let $ctrl = this;
    $ctrl.query.criteria.markerType = "Customer";
    if ($ctrl.tabIndex == 1) {
      $ctrl.query.criteria.markerType = "Activity";
      $ctrl.query.criteria.activityStartDate =
        $ctrl.startDate.format("DD/MM/YYYY");
      $ctrl.query.criteria.activityEndDate = $ctrl.endDate
        .clone()
        .add("days", 1)
        .format("DD/MM/YYYY");
    }
    if ($ctrl.searchIndex == "0") {
      if ($ctrl.query.criteria.Zip.length >= 5) {
        $ctrl.query.criteria.City = "";
        $ctrl.query.criteria.State = "";
        $ctrl.query.load(true);
      }
    } else if ($ctrl.searchIndex == "1") {
      if (
        $ctrl.query.criteria.City.length &&
        $ctrl.query.criteria.State.length
      ) {
        $ctrl.query.criteria.Zip = "";
        $ctrl.query.load(true);
      }
    }
  }

  selectStore(s) {
    let $ctrl = this;
    //        $ctrl.map.center = s.location;
    if (s.latitude) {
      $ctrl.map.store = s;
      $ctrl.map.instance.showInfoWindow("info", s.location);
    }
  }

  markerClicked(event, store) {
    let $ctrl = this.map.$ctrl;
    $ctrl.selectStore(store);
  }

  openMap(store) {
    const $ctrl = this;
    if (store.placeId) {
      window.open(
        "https://www.google.com/maps/search/?api=1&query=" +
          store.companyName +
          "&query_place_id=" +
          store.placeId
      );
    } else {
      $ctrl.lookupPlace(store, true);
    }
  }

  getGeoZip() {
    let $ctrl = this;
    if ($ctrl.mapConfig.defaultAddress) {
      $ctrl.map.center = $ctrl.mapConfig.defaultAddress;
      console.debug("BL*** $ctrl.map.center", $ctrl.map.center);
    }

    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(function (position) {
        console.warn("navigator.geolocation.getCurrentPosition", position);
        var geocoder = new google.maps.Geocoder();
        var latlng = {
          lat: position.coords.latitude,
          lng: position.coords.longitude,
        };
        geocoder.geocode({ location: latlng }, function (results, status) {
          console.debug("results, status", results, status);
          if (status === google.maps.GeocoderStatus.OK) {
            for (var i = 0; i < results.length; i++) {
              var result = results[i];
              for (var j = 0; j < result.address_components.length; j++) {
                var address_component = result.address_components[j];
                for (var k = 0; k < address_component.types.length; k++) {
                  var type = address_component.types[k];
                  if (type === "postal_code") {
                    $ctrl.query.criteria.ZipCode = address_component.short_name;
                    $ctrl.map.center = address_component.short_name + " USA";
                  }
                }
              }
            }
          }
        });
      });
    }
  }

  load() {
    return this.query.load();
  }
}

export default {
  bindings: {
    customer: "<",
    customerId: "@",
  },
  controller: CustomerMapController,
  templateUrl($element, $attrs) {
    return $attrs.templateUrl || templateUrl;
  },
};
